import NavItem from "./NavItem";
import Logo from "./Logo";
import HeaderCartShow from '@/components/layout/headers/HeaderCartShow';
import HeaderAccountSelector from '@/components/layout/headers/HeaderAccountSelector';

export default function Navbar({headerStyle, navBg, currency}) {
  const navItemsRaw = [
    { name: 'home', path: '/' },
    { name: 'catalog', path: '/catalog' },
    { name: 'blog', path: '/blog' },
    { name: 'faq', path: '/faq' },
    { name: 'contact', path: '/contact' },
  ];
  
  return (
    <div
      className={`col header-menu-column ${
        headerStyle === 2
          ? " menu-color-white"
          : headerStyle === 5
          ? "justify-content-center align-items-center flex-none"
          : ""
      }`}
    >
      {headerStyle === 5 ? <Logo sticky headerStyle={headerStyle} navBg={navBg}/> : ""}
      <div className={`header-menu ${headerStyle === 5 ? "header-menu-2" : "d-none d-xl-block "} `}>
        <nav>
          <div className="ltn__main-menu">
            <ul>
              {navItemsRaw.map((item, idx) => (
                <NavItem key={idx} item={item} />
              ))}
            </ul>
          </div>
        </nav>
      </div>
      {headerStyle === 5 ? (
          <div className="sticky-my-account">
            <HeaderAccountSelector/>
            <HeaderCartShow headerStyle={headerStyle} currency={currency}/>
          </div>
      ) : ''}
    </div>
  );
};
